'use strict';

customerZone.run(['$rootScope', '$route', 'utils', 'Session', '$log',
    function ($rootScope, $route, utils, Session, $log) {

        var previousRouteSlug;
        var previousSubscriptionId;

        if (!window.enableNgRouting) return;

        $rootScope.$on('$routeChangeStart', function(event, toRoute, fromRoute){
            if (toRoute.requiresAuth && !Session.authenticated()) {
                $log.debug('Auth required. Redirecting to login page');
                event.preventDefault();
                utils.goToLogin('' + window.location, toRoute.authExplanation, toRoute.emailLoginOnly);
            }
            else if (toRoute.accessible && !toRoute.accessible(Session)){
                $log.debug('Prerequisites. Redirecting to home page');
                event.preventDefault();
                if (Session.authenticated())
                    utils.goToProducts();
                else
                    utils.goToHome();
            }
            previousSubscriptionId = (Session.subscriber() || {}).id;
        });

        $rootScope.updateTitle = function(){
            document.title = utils.translate($route.current.title);
            $('body')
                .removeClass('route--'+previousRouteSlug)
                .addClass('route--'+$route.current.title);
            previousRouteSlug = $route.current.title;
        };

        $rootScope.$on(Session.SUBSCRIPTION_CHANGED_EVENT, function(event, subscriber){
            if ((subscriber || {}).id === previousSubscriptionId) return;
            previousSubscriptionId = (subscriber || {}).id;
            if ($route.current && $route.current.reloadOnSubscriptionChange)
                $route.reload();
        });
    }]);
